<template>
  <section class="results mt-50" id="real-results">
    <div class="container">
      <h2>Our Success Stories.</h2>
      <div class="row res_wrap">
        <div class="col-sm-3 col-xs-6" v-for="doc in documents" :key="doc.debt">
          <p>
            Total Debt {{doc.debt}}
            <span>Paid {{doc.paid}}</span>
          </p>

          <img :src="require(`../assets/${doc.img}`)" @click="modalDoc(doc)" v-b-modal.modal-lg />
          <p class="saved_text">SAVED {{doc.saved}}</p>
        </div>
      </div>
    </div>
    <b-modal id="modal-lg" size="lg" hide-footer title="Large Modal" v-if="docDetail != null">
      <div class="row res_wrap">
        <div class="col">
          <p>
            Total Debt {{docDetail.debt}}.
            <span>Paid {{docDetail.paid}}</span>
          </p>

          <img :src="require(`../assets/${docDetail.img}`)" />
          <p class="saved_text">SAVED {{docDetail.saved}}</p>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      docDetail: null,
      documents: [
        {
          img: "result-01.jpg",
          debt: "$60,444",
          paid: "$30,000",
          saved: "50%"
        },
        {
          img: "result-02.jpg",
          debt: "$6,517",
          paid: "$2,800",
          saved: "57%"
        },
        {
          img: "result-03.jpg",
          debt: "$3,622",
          paid: "$1,100",
          saved: "70%"
        },
        {
          img: "result-04.jpg",
          debt: "$22,222",
          paid: "$12,000",
          saved: "46%"
        }
      ]
    };
  },
  methods: {
    modalDoc(doc) {
      this.docDetail = doc;
    }
  }
};
</script>


<style lang="scss" >
#modal-lg {
  img {
    width: 100%;
  }
  p {
    color: #4460fd;
    font-weight: 700;
  }
}
.results h2 {
  color: #fff;
  margin-bottom: 25px;
  font-size: 36px;
  font-weight: 700;
}
.res_wrap a {
  display: inline-block;
  position: relative;
  text-decoration: none !important;
}
.res_wrap a:before {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

#real-results {
  background-image: url("../assets/results-bg.jpg");
  text-align: center;
  padding: 50px 0;
  background-size: cover;
  .saved_text {
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 10px;
  }
  img {
    width: 100%;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      transition: 0.2s;
      transform: scale(1.05);
    }
  }
  p {
    font-size: 18px;
    color: #fff;
    line-height: 1.3;
    background: #4460fd;
    padding: 5px;
    span {
      display: inline-block;
      width: 100%;
      color: #fff;
    }
  }
}
</style>